import { z } from 'zod';

const isoDateTime = () => z.string().datetime({ offset: true });

export const filterProfileSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  name: z.string().min(1),
  query: z.string(),
  isDefault: z.boolean(),
  createdAt: isoDateTime(),
  updatedAt: isoDateTime(),
});

export const filterProfileInputSchema = z.object({
  name: z.string().min(1),
  query: z.string(),
  isDefault: z.boolean().optional(),
});

export const filterProfileUpdateSchema = z.object({
  name: z.string().min(1).optional(),
  query: z.string().optional(),
  isDefault: z.boolean().optional(),
});
